import { ExSideDrawer } from '@boomi/exosphere';
import { useTranslation } from 'react-i18next';
import type { BoomiModel } from '@components/ModelsManagement/types/models.types';
import ModelCard, { type SelectableModel } from '@components/ModelsManagement/ModelCard/ModelCard';
import './BoomiModelsDrawer.scss';

interface BoomiModelsDrawerProps {
  open: boolean;
  models: BoomiModel[];
  onClose: () => void;
}

function BoomiModelsDrawer({
  open,
  models,
  onClose,
}: BoomiModelsDrawerProps) {
  const [t] = useTranslation('common');
  const selectableModels: SelectableModel[] = models.map((model) => ({
    id: '',
    model_id: model.model_id || model.id,
    name: model.display_name,
    version: '',
    provider: 'Boomi',
    boomi: true,
    category: 'LLM',
    description: model.description,
  }));

  return (
    <ExSideDrawer
      open={open}
      onClose={onClose}
      panelTitle="Boomi Models"
      className="boomi-models-drawer"
    >
      <div className="boomi-models-drawer__content">
        {selectableModels.length === 0 ? (
          <p className="boomi-models-drawer__empty">
            {t('no_boomi_models_available')}
          </p>
        ) : (
          <div className="boomi-models-drawer__list">
            {selectableModels.map((model) => (
              <ModelCard
                key={model.model_id}
                model={model}
                selected={false}
                disabled
              />
            ))}
          </div>
        )}
      </div>
    </ExSideDrawer>
  );
}

BoomiModelsDrawer.defaultProps = {};

export default BoomiModelsDrawer;
